<app-card class="page-container">
  <app-card-header>
    <app-card-title>
      <div class="header-content">
        <app-icon name="tag" />
        <span>{{ 'chooseInstance.title' | translate }}</span>
      </div>
    </app-card-title>
  </app-card-header>

  <app-card-content class="scrollable-content">
    @if (loading()) {
    <div class="loading-container">
      <app-spinner />
      <p>{{ 'submission.record.loading' | translate }}</p>
    </div>
    }

    @if ((error() || initError()) && !loading()) {
    <div class="error-message" data-testid="error-message">
      <app-icon name="alert-circle" />
      <p>{{ error() || initError() }}</p>
    </div>
    }

    @if (!loading() && !(error() || initError()) && checkPoint()) {
    <div class="content-container">
      <div class="checkpoint-info" data-testid="checkpoint-info">
        <h3>{{ checkPoint()!.name }}</h3>
        @if (form()) {
        <p class="form-name">{{ form()!.name }}</p>
        }
      </div>

      <div class="instances-section">
        <h4>{{ 'chooseInstance.instructions' | translate }}</h4>

        <div class="instance-list">
          @for (instance of instances(); track instance.id) {
          <button class="instance-card" (click)="selectInstance(instance)"
            [attr.data-testid]="'instance-' + instance.serial_number">
            <div class="instance-icon">
              <app-icon name="tag" [size]="24" />
            </div>
            <div class="instance-info">
              <h5>{{ 'chooseInstance.unitLabel' | translate: { serial: instance.serial_number } }}</h5>
            </div>
            <div class="instance-arrow">
              <app-icon name="chevron-right" />
            </div>
          </button>
          }
        </div>

        <div class="skip-section">
          <app-button variant="text" (click)="skipInstance()" data-testid="skip-instance-button">
            {{ 'chooseInstance.skipButton' | translate }}
          </app-button>
        </div>
      </div>
    </div>
    }
  </app-card-content>
</app-card>